import React, { useEffect } from 'react';
import { CContainer, CButton } from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { cilPlus } from '@coreui/icons';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { getWeaveTypeRequestAction } from '../../store/weaveType/weaveTypeActions';
import WeaveTypeTable from '../../components/WeaveTypeTable/WeaveTypeTable';
import { useTranslation } from '../../hooks/useTranslation';
const WeaveType = ({ getWeaveTypeRequest }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  useEffect(() => {
    getWeaveTypeRequest({});
  }, [getWeaveTypeRequest]);

  return (
    <div className="weavetype-page-container">
      <CContainer>
        <div className="text-fs-head-sm text-start mb-3">{t('weaveTypes')}</div>
        <WeaveTypeTable />
      </CContainer>

      <CButton
        color="primary"
        className="create-order-fab"
        onClick={() => navigate('/weavetype/create')}
      >
        <CIcon icon={cilPlus} size="lg" />
      </CButton>
    </div>
  );
};

export default connect(null, { getWeaveTypeRequest: getWeaveTypeRequestAction })(WeaveType);
